import { render, staticRenderFns } from "./electricChart.vue?vue&type=template&id=0481ef57&scoped=true"
import script from "./electricChart.vue?vue&type=script&lang=js"
export * from "./electricChart.vue?vue&type=script&lang=js"
import style0 from "./electricChart.vue?vue&type=style&index=0&id=0481ef57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481ef57",
  null
  
)

export default component.exports